import { Colors } from "@/enums/Colors";
import { SxProps, styled } from "@mui/material";
import CompanySVG from "../../../assets/images/defaultCompany.svg";
import UserIconSVG from "../../../assets/images/user-profile.svg";

interface Props {
  src?: string;
  sx?: SxProps;
  alt?: string;
  company?: boolean;
}

export default function UserImage(props: Props) {
  return (
    <StyledImg
      sx={props.sx}
      src={props.src || ""}
      onError={({ currentTarget }) => {
        currentTarget.onerror = null;
        currentTarget.src = props.company ? CompanySVG.src : UserIconSVG.src;
      }}
      alt={props.alt}
    />
  );
}

const StyledImg = styled("img")(() => ({
  width: "2rem",
  height: "2rem",
  objectFit: "contain",
  border: `1px solid ${Colors.LIGHT_GRAY_DEDEE1}`,
  borderRadius: "0.25rem",
}));
